const l = [];
function x() {
  const r = {}, o = {}, d = (e, n) => {
    const t = "before" in n ? n.before : void 0, s = "after" in n ? n.after : void 0;
    if (t) {
      const i = e.findIndex((c) => t.includes(c.key));
      if (i !== -1)
        return i;
    }
    if (s) {
      const i = e.findIndex((c) => s.includes(c.key));
      if (i !== -1)
        return i + 1;
    }
    return e.length;
  }, u = (e, n) => {
    const t = r[e], s = t.indexOf(n);
    s !== -1 && (t.splice(s, 1), f(e));
  }, f = (e) => {
    o[e]?.forEach((n) => n());
  };
  return {
    getItems(e) {
      return r[e] ?? l;
    },
    subscribe(e, n) {
      const t = o[e] ??= /* @__PURE__ */ new Set();
      return t.add(n), () => t.delete(n);
    },
    register(e, n) {
      const t = r[e];
      if (t) {
        const s = d(t, n);
        r[e] = [...t.slice(0, s), n, ...t.slice(s)];
      } else
        r[e] = [n];
      return f(e), () => u(e, n);
    }
  };
}
export {
  x as createApplicationMenu
};
